import { ProfileModel } from '@/http/models/Profile'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { ProfileHttpParams } from '@/types/http-params/ProfileHttpParams'

export const useChangePassword = () => {
  return useMutation({
    mutationFn: (body: ProfileHttpParams.ChangePassword['body']) =>
      ProfileModel.changePassword({ body }),
    onSuccess: (response) => {
      if (response.success) {
        toast.success('Password changed successfully')
      } else {
        toast.error(response.error?.data?.message || 'Failed to change password')
      }
    },
    onError: (error: any) => {
      toast.error(error.message || 'Something went wrong')
    },
  })
}
